export interface GarageTask {
  id: number;
  key: string;
  description: string;
  type: GarageTaskType;
  plannedDuration?: string | null; // Time/Interval -> nur bei type: 'FIXED_PRICE' gesetzt (beim Kalender nur UNPRODUCTIVE)
  group: string;
  color: string;
}

export enum GarageTaskType {
  FIXED_PRICE = '#GARAGE_ROSTER.GARAGE_TASKS.FIXED_PRICE',
  TIME_BASED = '#GARAGE_ROSTER.GARAGE_TASKS.TIME_BASED',
  UNPRODUCTIVE = '#GARAGE_ROSTER.GARAGE_TASKS.UNPRODUCTIVE',
}
